// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1385":"77b369ec","2589":"d58c8f4e","9103":"b9ea4917","9400":"363a8620"}[chunkId] + ".css";
};